import styled from 'styled-components';
import {dFlexCenter} from '../../../globalVariables/GlobalFlex';

export const label = styled.span`
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--border-radius-border-radius-full);
    background: var(--primitive-black);
    color: var(--color-text-default);
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1;
    white-space: nowrap;
    box-shadow: 0 0 16px 2px var(--primitive-white);
`;

export const iconCircle = styled.span`
    width: 44px;
    height: 44px;
    flex: none;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--primitive-black);
    color: var(--color-text-default);
    ${dFlexCenter};
    box-shadow: 0 0 16px 2px var(--primitive-white);
`;

export const item = styled.button`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: var(--space-md);
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    pointer-events: none;
    opacity: 0;
    transform: translateY(8px) scale(0.9);
    transition: opacity 0.2s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

    &.danger ${label},
    &.danger ${iconCircle} {
        background: var(--color-state-error-main);
    }
`;

export const scrim = styled.div`
    position: fixed;
    inset: 0;
    z-index: 44;
    background: rgba(0, 0, 0, 0.55);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.25s ease;

    &.is-open {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
`;

export const menu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-md);
`;

export const fab = styled.button`
    width: 56px;
    height: 56px;
    flex: none;
    border: none;
    cursor: pointer;
    pointer-events: auto;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-brand-main);
    color: var(--primitive-black);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    ${dFlexCenter};
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), background 0.2s ease;

    &:hover {
        background: var(--color-brand-hover);
    }
`;

export const wrap = styled.div`
    position: absolute;
    inset-inline-start: calc((100% - var(--card-w)) / 2 - 9px);
    bottom: calc((100% - 690px * var(--card-scale)) / 2 - 28px);
    z-index: 45;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-lg);
    pointer-events: none;

    &.is-open ${item} {
        opacity: 1;
        transform: none;
        pointer-events: auto;
    }
    &.is-open ${item}:nth-last-child(1) { transition-delay: 0.04s; }
    &.is-open ${item}:nth-last-child(2) { transition-delay: 0.09s; }
    &.is-open ${item}:nth-last-child(3) { transition-delay: 0.14s; }
    &.is-open ${item}:nth-last-child(4) { transition-delay: 0.19s; }
    &.is-open ${item}:nth-last-child(5) { transition-delay: 0.24s; }
    &.is-open ${fab} { transform: rotate(90deg); }

    @media (prefers-reduced-motion: reduce) {
        ${item} { transition: opacity 0.2s ease; }
    }
`;
